import { useMutation } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

/*
 * Link Preview API Types
 */
export interface LinkPreviewData {
	url: string;
	title?: string;
	description?: string;
	image_url?: string;
	site_name?: string;
}

interface LinkPreviewError {
	error: string;
}

/*
 * Mutation Hooks
 */

interface FetchLinkPreviewOptions {
	onError?: (error: unknown) => void;
	onSuccess?: (data: LinkPreviewData) => void;
}

export const useFetchLinkPreview = (options: FetchLinkPreviewOptions = {}) => {
	const http = useHttpClient('v2');

	return useMutation({
		mutationFn: async (url: string): Promise<LinkPreviewData> => {
			const res = await http.post<LinkPreviewData | LinkPreviewError>('link_previews', { url });

			if ('error' in res.data) {
				throw new Error(res.data.error);
			}

			return res.data;
		},
		onSuccess: (data) => options.onSuccess?.(data),
		onError: (error) => options.onError?.(error),
	});
};
